import { Row, Typography } from 'antd';
import React, { memo } from 'react';

const { Title } = Typography;

interface IProps {
  tyres: JSON;
}

export const Tyres: React.FC<IProps> = memo(({ tyres }) => {
  return (
    <>
      {tyres &&
        Object.keys(tyres).map((key, index) => {
          return (
            <Row key={`${key}${index}`}>
              {tyres[key as never] && (
                <>
                  <Title level={5}>
                    {key}: {tyres[key as never]}
                  </Title>
                </>
              )}
            </Row>
          );
        })}
    </>
  );
});
